// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const item = "CategoriesListMobile__item__Zlb3f";
export const items = "CategoriesListMobile__items__ZJhjc";
export const medium = "500";
export const member = "CategoriesListMobile__member__6pI06";
export const others = "CategoriesListMobile__others__gwvZA";
export const peers = "CategoriesListMobile__peers__2Gi0v";
export const regular = "400";
export const row = "CategoriesListMobile__row__njGI8";
export const rowLabel = "CategoriesListMobile__rowLabel__SPM0u font-faces__sansMedium__DqLMY font-faces__sans__uCf65";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const shaded = "CategoriesListMobile__shaded__QyuDr";
export const totalRow = "CategoriesListMobile__totalRow__ECuZD";